import { LucideIconData } from 'lucide-angular';

export const PoolCaC6: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M8 7 v10' }],
  ['path', { d: 'M16 7 v10' }],
  ['path', { d: 'M8 10 h8' }],
  ['path', { d: 'M8 14 h8' }],
];
